import React from 'react';
import { notification } from 'antd';
import { isEmpty } from 'lodash';

export const onFinishFailed = ({ errorFields }: any) => {
  if (errorFields !== undefined && !isEmpty(errorFields)) {
    const description = errorFields
      ?.map((error: any) => error?.errors.flat())
      ?.map((error: string) => (
        <>
          {'- ' + error}
          <br />
        </>
      ));

    notification.error({
      message:
        localStorage.getItem('lancode') === 'EN'
          ? 'Validation error'
          : 'Erreur de validation',
      description,
    });
  }
};
